import React, {useEffect, useState} from 'react';
import {Button} from "@material-ui/core";
import {getScheduleByIdPunkt} from "@cabinet-packages/api/api";
import {ConfirmDialog, CustomDialog, LineDialog, Loading} from "@cabinet-packages/components";
import moment from 'moment';
import 'moment/locale/uk';
import {useDispatch, useSelector} from "react-redux";
import {addSelectedPunkt, getSchedule, loginClient, setAssayTime,} from "@cabinet-packages/redux";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {isOrderedAssaysHasPunkts} from "@cabinet-packages/helpers";
import {useHistory} from "react-router-dom";
import ConfirmOrder from "../ConfirmOrder";
import themeMaterialUI from "../settings/themeMaterialUI";
import {Close} from "@material-ui/icons";
import useStyles from "./styles";
import SelectedMonth from "./components/SelectedMonth";
import SelectedDay from "./components/SelectedDay";
import Signs from "./components/Signs";
import {getAllPunkts} from "@cabinet-packages/redux/actions/actionsCreators";

moment.locale('uk');
const ukMonths = ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень",
    "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"];

const AssaySchedulerTime = ({isComponentInShop, dataPickers}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const [selected, setSelected] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [userData, setUserData] = useState(null);
    const [months, setMonths] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedWorkDays, setSelectedWorkDays] = useState(null);
    const [monthDays, setMonthDays] = useState(null);
    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);
    const [open, setOpen] = useState(false);
    const {punkts} = useSelector(store => store.collectionPoints);
    const {selectedPunkt} = useSelector(store => store.orderAssays);
    const { activePatient } = useSelector(store => store.patients);
    const { schedule } = useSelector(state => state.scheduleOfOrders);
    const [selectedSchedule, setSelectedSchedule] = useState(null);
    const [isUserConfirmTime, setIsUserConfirmTime] = useState(false);
    const [orderShow, setOrderShow] = useState(false);
    const [showConfirmOrder, setShowConfirmOrder] = useState(false);
    const [isUserTap, setIsUserTap] = useState(false);
    const [scheduleForSelectedDay, setScheduleForSelectedDay] = useState(null);
    const [year, setYear] = useState(moment().year());

    const handleChoseAnotherMonth = (event, direction) => {
        event.preventDefault();
        event.stopPropagation();
        const indexOfSelectedMonth = months.indexOf(selectedMonth);

        if (months.length === 1) return;

        if (direction === 'back') {
            if (ukMonths.indexOf(selectedMonth) === 0) {
                setYear(moment().year(year).subtract(1, 'years').year());
            }
            if (indexOfSelectedMonth === 0) {
                setSelectedMonth(months[months.length - 1]);
            } else {
                setSelectedMonth(months[indexOfSelectedMonth - 1]);
            }
        } else if (direction === 'forward') {
            if (ukMonths.indexOf(selectedMonth) === 11) {
                setYear(moment().year(year).add(1, 'years').year());
            }
            if (indexOfSelectedMonth === months.length - 1) {
                setSelectedMonth(months[0]);
            } else {
                setSelectedMonth(months[indexOfSelectedMonth + 1]);
            }
        }

        setSelectedWorkDays(null);
        setMonthDays(null);
        setSelectedDay(null);
        setSelectedTime(null);
        setScheduleForSelectedDay(null);
    };

    const handleClickOnDay = (event, dayNum) => {
        event.preventDefault();
        event.stopPropagation();
        setScheduleForSelectedDay(null);

        const scheduleForSelectedDay = selectedWorkDays
            .filter(item => moment(item.dt_start).date() === dayNum && moment(item.dt_start).year() === year)
            .sort((a, b) => {
                if (moment(a.dt_start).hour() > moment(b.dt_start).hour()) {
                    return 1;
                } else {
                    return -1
                }
            });

        const selectedDayAllWorkingTime = scheduleForSelectedDay.reduce((acu, cur, idx, src) => {
            if (src.length === 1) {
                return cur;
            }

            if (idx === 0) {
                return {...acu, dt_start: cur.dt_start, month: cur.month};
            } else if (idx === src.length - 1) {
                return {...acu, dt_end: cur.dt_end}
            } else {
                return acu;
            }
        }, {});

        setScheduleForSelectedDay(scheduleForSelectedDay);

        const selectedDay = {
            ...selectedDayAllWorkingTime,
            receptionHours: []
        }

        const startHour = moment(selectedDay.dt_start).hour()
        const endHour = moment(selectedDay.dt_end).hour()
        const startMinutes = moment(selectedDay.dt_start).minutes()

        for (let i = startHour; i < endHour; i++) {
            for (let j = 0; j < 60; j+=20) {
                if (!(i===startHour && startMinutes > j)) {
                    selectedDay.receptionHours.push(j === 0
                        ? i === startHour ? `${i}:${startMinutes}` : `${i}:00`
                        : `${i}:${j}`)
                }
            }
        }

        setSelectedDay({...selectedDay, receptionHours: selectedDay.receptionHours.reduce((acu, cur, idx) => {
                if (idx === 0) return [[cur]];
                if ((idx)%3 === 0) return [...acu, [cur]];
                acu[Math.ceil(((idx+1)/3)-1)] = [...acu[Math.ceil(((idx+1)/3)-1)], cur]
                return acu;
            }, [])});
        setSelectedTime(null);
    };

    const handleClickOnTime = (event, time) => {
        event.preventDefault();
        event.stopPropagation();

        setSelectedTime(time);

        CustomDialog(ConfirmDialog,
            {text: `Ви обрали запис на ${selectedDay.dt_start.slice(0, 10)} ${time} за адресою: ${selectedPunkt.address}. Підтвердити вибраний час?`,
                onCancel: () => {
                    setSelectedTime(null);
                },
                onConfirm: () => {
                    dispatch(setAssayTime({date: `${selectedDay.dt_start.slice(0, 10)} ${time}`}));
                    setIsUserConfirmTime(true);
                    !activePatient && dispatch(loginClient(themeMaterialUI))
                    !activePatient && dataPickers && dispatch(setAssayTime({date: `${selectedDay.dt_start.slice(0, 10)} ${time}`}));
                    setShowConfirmOrder(true);
                }}, false,
            themeMaterialUI);
    };

    const handleClose = () => {
        setOpen(false);
        setIsUserTap(true);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleTransitionToLineRugPick = (point, isComponentInShop) => {
        CustomDialog(LineDialog,
            {point, isComponentInShop, history, themeMaterialUI},
            false,
            themeMaterialUI);
    };

    const handleChangePunkt = (event, value) => {
        event.stopPropagation();
        event.preventDefault();

        dispatch(addSelectedPunkt(value));
        setSelected(value);
        setUserData(null);
        setSelectedWorkDays(null);
        setMonthDays(null);
        setSelectedDay(null);
        setSelectedTime(null);
        setIsError(false);
        setSelectedSchedule(null);
        setSelectedMonth(null);
        setIsUserTap(true);
    };

    useEffect(() => {
        async function getUserData() {
            try {
                setIsLoading(true);
                const data = await getScheduleByIdPunkt(selectedPunkt.idPunkt);

                if (data && data.length === 1) {
                    setUserData(...data
                        .map(item => ({
                            ...item,
                            workHours: JSON.parse(item.workHours)
                                .map(item => ({...item, month: ukMonths[moment(item.dt_start).month()]}))}))
                    );
                } else if (data && data.length === 0) {
                    setIsError('Вибачте, для даного відділення попередній запис не проводиться. \n'+
                        'Запрошуємо Вас у порядку живої черги!\n')
                } else if (data === undefined) {
                    setIsError(true)
                } else {
                    setUserData(data);
                }
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                setIsError(error);
            }
        }
        if (!userData && !isError && selectedPunkt) {
            getUserData();
        }
        if (userData && !isError && !months) {
            // setMonths(ukMonths);
            setMonths(userData.workHours
                .sort((a, b) => a.dt_start.localeCompare(b.dt_start))
                .map(item => item.month)
                .reduce((acu, cur) => {
                    if (acu.includes(cur)) {
                        return acu;
                    }

                    return [...acu, cur];
            }, []));
        }
        if (!selectedMonth && months) {
            setSelectedMonth(months[0]);
        }

        if (selectedMonth && !selectedWorkDays && userData) {
            setSelectedWorkDays(userData.workHours.filter(item => item.month === selectedMonth && moment(item.dt_start).year() === year));
        }
        if (selectedMonth && !monthDays) {
            const monthFirstDay = moment().year(year).month(selectedMonth).startOf('month').weekday();
            const lengthOfMonth = moment().year(year).month(selectedMonth).endOf('month').date();

            const arrayOfDays = [];
            for (let i = 0; i < monthFirstDay; i++) {
                arrayOfDays.push({dayNum: ''})
            }
            for (let i = 1; i <= lengthOfMonth; i++) {
                arrayOfDays.push({dayNum: i})
            }
            setMonthDays(arrayOfDays.reduce((acu, cur, idx) => {
                if (idx === 0) return [[cur]];
                if ((idx)%7 === 0) return [...acu, [cur]];
                acu[Math.ceil(((idx+1)/7)-1)] = [...acu[Math.ceil(((idx+1)/7)-1)], cur]
                return acu;
            }, []));
        }
        if (!punkts) {
            dispatch(getAllPunkts(false, false));
        }
        if (punkts && !selected && !selectedPunkt && !isUserTap) {
            setSelected(punkts[0]);
            dispatch(addSelectedPunkt(punkts[0]));
        }
        if (punkts && selectedPunkt && !selected) {
            setSelected(selectedPunkt)
        }
        if (!schedule) {
            dispatch(getSchedule());
        }
        if (schedule && selectedPunkt && !selectedSchedule) {
            setSelectedSchedule(schedule.filter(item => item.idPunkt === selectedPunkt.idPunkt).map(item => {
                if (item) {
                    const spitedDate = item.dt.split(' ');
                    const date = spitedDate[0].split('.');

                    return ({
                        ...item,
                        dt: `${date[2]}-${date[1]}-${date[0]} ${spitedDate[1]}`
                    })
                } else {
                    return item;
                }
            }))
        }
        if (activePatient && showConfirmOrder && !orderShow) {
            setOrderShow(true);
            setShowConfirmOrder(false);
        }
    }, [userData, isError, months, selectedMonth, selectedWorkDays, monthDays, selectedPunkt, punkts, dispatch,
        selected, selectedSchedule, activePatient, isUserConfirmTime, history, isComponentInShop, schedule,
        selectedTime, orderShow, showConfirmOrder, isUserTap]);

    return (<>
        {orderShow ? <ConfirmOrder
            dataPickers={true}
            themeMaterialUI={themeMaterialUI}
            setOrderShow={(notUpdTime) => {
                setOrderShow(false);
                if (notUpdTime) {
                    handleOpen(true);
                } else {
                    setSelectedTime(null);
                }
        }}/>
    : <div className={classes.root}>
        <div className={classes.autocompleteWrapper}>
            {<Autocomplete
                className={classes.autoComplete}
                id="combo-box"
                closeIcon={<Close fontSize="small"/>}
                open={open}
                onOpen={handleOpen}
                onClose={handleClose}
                value={selected}
                freeSolo
                options={punkts
                    ? isOrderedAssaysHasPunkts()
                        ? isOrderedAssaysHasPunkts()
                        : punkts
                    : []}
                getOptionLabel={(option) => option.address}
                onChange={handleChangePunkt}
                style={{width: 300}}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Введіть назву пункту"
                        variant="outlined"
                    />)
                }
            />}
        </div>
        {!selected && isUserTap && !isLoading && !isError && <div className={classes.error}>Введіть адресу пункту або виберіть зі списку.</div>}
        {isLoading && <Loading/>}
        {isError && typeof isError === 'string' && <div className={classes.error}>
            <div className="content" dangerouslySetInnerHTML={{__html: isError}}/>
        </div>}
        {isError && typeof isError !== 'string' &&
        <div className={classes.error}>Вибачте, сталась помилка під час завантаження.</div>}
        <div className={classes.setDateWrapper}>
            <SelectedMonth selectedMonth={selectedMonth} selectedDay={selectedDay} monthDays={monthDays} months={months}
                           handleChoseAnotherMonth={handleChoseAnotherMonth} handleClickOnDay={handleClickOnDay}
                           selectedWorkDays={selectedWorkDays} year={year}
            />
            <SelectedDay selectedDay={selectedDay} handleClickOnTime={handleClickOnTime} selectedTime={selectedTime}
                         scheduleForSelectedDay={scheduleForSelectedDay} selectedSchedule={selectedSchedule}
            />
        </div>
        <Signs selectedWorkDays={selectedWorkDays} months={months} selectedMonth={selectedMonth}/>
            {!dataPickers && <Button
                variant="outlined"
                className={classes.orderActionButton}
                color="secondary"
                onClick={() => history.goBack()}
            >
                повернутись назад
            </Button>}
    </div>
} </>
    );
};

export default AssaySchedulerTime;
